<template>
	<Dialog :header="titulo" :visible=showProgreso :modal="true" position="center" :style="{ width: '400px' }" :closable="cerrar">
        <ProgressBar mode="indeterminate"/>
    </Dialog>
</template>
<script>

export default ({
    name:'DialogoProgreso',
    props: {
        titulo: {
            type: String,
            default: () =>'La operacion se está ejecutando'
        },
        showProgreso: {
            type: Boolean,
            default: true
        }
    },
    data(){
        return{
            cerrar:false
        }
    }  
})
</script>